import { Pipe, PipeTransform } from '@angular/core';
import { RowsGroup } from '../components/table/assign-table.component';

@Pipe({
  name: 'calculateGroupTableHeight',
  standalone: false,
})
export class CalculateGroupTableHeightPipe implements PipeTransform {
  transform(group: RowsGroup, maxHeight: number = 500): number {
    const rows = group.rows;
    return rows.length * 48 > maxHeight ? maxHeight : rows.length * 48 + 20;
  }
}
